module.exports = __webpack_public_path__ + "static/media/400098_01.63164da4.png";